import React from 'react';

import { Bubble } from '@lt/components';
import { LuggageModern } from '@lt/components/icons-react/userflow';
import { useTranslation } from '@lt/localization';
import FlightsLuggageItem from 'src/components/Luggage/FlightsLuggageItem';
import { luggageToArray } from 'src/components/Luggage/luggageUtils';
import styled from 'styled-components';

import type { LuggageTypes } from '@lt/api/dist/methods/packages/types';
import type { LuggageItem } from 'src/components/Luggage/types';
import { FLIGHTS_DIRECTIONS } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';

interface FlightsLuggageSummaryProps {
  summaryLuggage: LuggageTypes[];
}

const FlightsLuggageSummary = ({
  summaryLuggage,
}: FlightsLuggageSummaryProps) => {
  const { t } = useTranslation();

  const BubbleContent = (
    <ContentWrapper>
      <ul>
        {summaryLuggage.map((luggage, index) => {
          const luggageArray = luggageToArray(luggage);
          return (
            <ListItem key={FLIGHTS_DIRECTIONS[index]}>
              <div>
                {`${FLIGHTS_DIRECTIONS[index]} – `}
                <FlightsLuggageItem
                  luggageArray={luggageArray as LuggageItem[]}
                />
              </div>
            </ListItem>
          );
        })}
      </ul>
      <Explanation>{t('checkout.flight.luggage.tooltip')}</Explanation>
    </ContentWrapper>
  );
  return (
    <StyledBubble
      title={t('checkout.flight.luggage.title')}
      closeable
      eventType="click"
      inline
      text={BubbleContent}
      width="max"
    >
      <LuggageInfoButton>
        <StyledLuggageModern width="25" height="24" />
        {t('checkout.flight.luggage.button_text')}
      </LuggageInfoButton>
    </StyledBubble>
  );
};

const StyledBubble = styled(Bubble)`
  margin-bottom: 8px;
  > div {
    width: 100%;
  }
`;

const LuggageInfoButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  background: #e6f2ff;
  border-radius: 4px;
  padding: 8px 12px 8px 8px;
  border: none;
  font-size: 14px;
  line-height: 16px;
  color: #007aff;

  &:hover {
    color: #179fe3;

    path {
      fill: #179fe3;
    }
  }
`;

const StyledLuggageModern = styled(LuggageModern)`
  path {
    fill: #007aff;
  }
`;

const ContentWrapper = styled.div`
  margin-top: 6px;
`;

const ListItem = styled.li`
  margin-bottom: 10px;
`;

const Explanation = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.colors.blackLight};
`;

export default FlightsLuggageSummary;
